import { render, staticRenderFns } from "./WABAChannelDetail.vue?vue&type=template&id=129e25af&scoped=true"
import script from "./WABAChannelDetail.vue?vue&type=script&lang=js"
export * from "./WABAChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./WABAChannelDetail.vue?vue&type=style&index=0&id=129e25af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129e25af",
  null
  
)

export default component.exports